app.directive('refreshCalendarView', function () {
    var noop = function () {
    };
    var refreshDpOnNotify = function (dpCtrl) {
        return function () {
            dpCtrl.refreshView();
        };
    };
    return {
        require: 'uibDatepicker',
        link: function (scope, elem, attrs, dpCtrl) {
            var refreshPromise = scope[attrs.refreshCalendarView];
            refreshPromise.then(noop, noop, refreshDpOnNotify(dpCtrl));
        }
    };
});